/**
 * Systematic debug logger for production troubleshooting.
 * Preserves console logs while removing global state collectors.
 */
export const debugLog = (tag: string, message: string, data?: any) => {
  // Console log with specific styling for visibility
  console.log(`%c[${tag}] %c${message}`, 'color: #dea01e; font-weight: bold;', 'color: #fff;', data || '');
};

export const getDebugLogs = () => {
  return [];
};

export const clearDebugLogs = () => {
  // No-op
};